import parsePhoneNumber, { CountryCode } from 'libphonenumber-js/mobile';
import isEmpty from 'lodash/isEmpty';

export default function checkValidPhoneNumber(
  phoneNumber: string,
  countryCode: CountryCode = 'TW',
): {
  formattedPhoneNumber: string;
  error?: string;
} {
  if (isEmpty(phoneNumber)) {
    return {
      formattedPhoneNumber: '',
      error: 'loginForm.error.missingPhone',
    };
  }

  const parsedPhoneNumber = parsePhoneNumber(phoneNumber, countryCode);

  if (!parsedPhoneNumber) {
    return {
      formattedPhoneNumber: '',
      error: 'loginForm.error.failedValidPhone',
    };
  }

  if (!parsedPhoneNumber.isValid() || !parsedPhoneNumber.isPossible()) {
    return {
      formattedPhoneNumber: '',
      error: 'loginForm.error.invalidPhone',
    };
  }

  console.log('phone type ', parsedPhoneNumber.getType());
  if (parsedPhoneNumber.getType() !== 'MOBILE') {
    return {
      formattedPhoneNumber: '',
      error: 'loginForm.error.notMobilePhone',
    };
  }

  return {
    formattedPhoneNumber: parsedPhoneNumber.number as string,
  };
}
